import { CardContent, Card, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import { withRouter } from "react-router-dom";
import SubmenuHeader from "../components/menus/SubMenuHeader";
import auth, { get, messageDialog, post } from "../js/auth";
import CardHeader from '@material-ui/core/CardHeader';

import { makeStyles } from '@material-ui/core/styles';

class ChoiceQR extends Component {

    state = {
        connectInfo: null,
        copied: false,
        phase: "ready", // ready | waiting | connected
        checkCount: 0,
    }

    pollTimer = null;

    componentWillUnmount() {
        this.stopPolling();
    }

    constructor(props) {
        super(props);

        this.useStyles = makeStyles((theme) => ({
            root: {
                width: '100%',
            },
            heading: {
                fontSize: theme.typography.pxToRem(15),
                flexBasis: '33.33%',
                flexShrink: 0,
            },
            secondaryHeading: {
                fontSize: theme.typography.pxToRem(15),
                color: theme.palette.text.secondary,
            },
        }));
    }

    render() {
        if (!this.props.myStatus || !this.props.myStatus.restaurant_settings || !this.props.myStatus.restaurant_settings["enabled-features"] || !this.props.myStatus.restaurant_settings["enabled-features"].choiceqr) {
            return <div></div>;
        }
        return <div style={{ flexGrow: 1, flexShrink: 1, display: "flex", flexFlow: "column", overflowY: "hidden", height: "100%" }}>
            <SubmenuHeader {...this.props} header={I18n.t("admin_local.menus.choiceqr_administration")} />
            <div id="choiceqrsynchronizer" style={{ overflowY: "hidden", height: "100%", width: "100%" }}>
                <div style={{ overflowY: "hidden", height: "100%", width: "100%" }}>
                    <Card style={{ width: "100%", background: "transparent", overflowY: "hidden", height: "-webkit-fill-available" }}>
                        <CardHeader title={I18n.t("admin_local.status")} action={null} />
                        <CardContent style={{ background: "transparent", overflowY: "auto", height: "100%", width: "100%" }}>
                            {this.props.myStatus.restaurant_settings["enabled-features"].choiceqr.places ? this.props.myStatus.restaurant_settings["enabled-features"].choiceqr.places.filter(p => p.enabled).map(place =>
                                <div key={place.name} style={{ marginBottom: 24, padding: 12, border: "1px solid #eee", borderRadius: 8, background: "#fafafa" }}>
                                    <div style={{ fontWeight: "bold", fontSize: "1.2rem", marginBottom: 8 }}>{place.name}</div>
                                    <div style={{ display: "flex", gap: 12 }}>
                                        {place.varSymbol ?
                                            <button type="button" className="btn btn-primary" onClick={() => this.onClick(place.varSymbol)}>
                                                {I18n.t("admin_local.upload_menu")}
                                            </button>
                                            :
                                            <button type="button" className="btn btn-primary" onClick={() => this.onConnect(place)}>
                                                {I18n.t("admin_local.connect_choiceqr")}
                                            </button>
                                        }
                                    </div>
                                </div>
                            ) : null}
                        </CardContent>
                    </Card>
                </div>
            </div>
            {this.renderConnectDialog()}
        </div>
    }

    renderConnectDialog = () => {
        const info = this.state.connectInfo;
        if (!info) {
            return null;
        }
        return <Dialog open={true} onClose={this.closeConnectDialog}>
            <DialogTitle>{I18n.t("admin_local.connect_choiceqr")}</DialogTitle>
            <DialogContent>
                {this.state.phase === "connected" ?
                    <div style={{ fontWeight: "bold", color: "green" }}>{I18n.t("admin_local.choiceqr_connected")}</div>
                    : <React.Fragment>
                        <div style={{ marginBottom: 12 }}>{I18n.t("admin_local.choiceqr_connect_token_info")}</div>
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <span style={{ fontSize: "1.2rem", fontWeight: "bold", wordBreak: "break-all" }}>{info.token}</span>
                            <button type="button" className="btn btn-primary" onClick={this.copyToken}>
                                {this.state.copied ? I18n.t("admin_local.choiceqr_copied") : I18n.t("admin_local.choiceqr_copy")}
                            </button>
                        </div>
                        {this.state.phase === "waiting" ?
                            <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 16 }}>
                                <CircularProgress size={24} />
                                <span>{I18n.t("admin_local.choiceqr_waiting")} ({this.state.checkCount})</span>
                            </div>
                            : null}
                    </React.Fragment>}
            </DialogContent>
            <DialogActions>
                {this.state.phase === "connected" ?
                    <button type="button" className="btn btn-primary" onClick={this.closeConnectDialog}>
                        {I18n.t("admin_local.close")}
                    </button>
                    : <React.Fragment>
                        <button type="button" className="btn btn-secondary" onClick={this.closeConnectDialog}>
                            {I18n.t("admin_local.cancel")}
                        </button>
                        {this.state.phase === "waiting" ? null :
                            <button type="button" className="btn btn-primary" onClick={this.openConnectUrl}>
                                {I18n.t("admin_local.choiceqr_open_connect")}
                            </button>}
                    </React.Fragment>}
            </DialogActions>
        </Dialog>;
    }

    copyToken = () => {
        const token = String(this.state.connectInfo.token || "");
        const done = () => this.setState({ copied: true });
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(token).then(done);
        } else {
            const ta = document.createElement("textarea");
            ta.value = token;
            document.body.appendChild(ta);
            ta.select();
            document.execCommand("copy");
            document.body.removeChild(ta);
            done();
        }
    }

    closeConnectDialog = () => {
        this.stopPolling();
        this.setState({ connectInfo: null, copied: false, phase: "ready", checkCount: 0 });
    }

    openConnectUrl = () => {
        window.open(this.state.connectInfo.url, "_blank", "noopener,noreferrer");
        this.setState({ phase: "waiting", checkCount: 0 });
        this.startPolling(this.state.connectInfo.placeName);
    }

    startPolling = (placeName) => {
        this.stopPolling();
        this.pollTimer = setInterval(() => this.checkConnected(placeName), 10000);
    }

    stopPolling = () => {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }

    checkConnected = (placeName) => {
        get("adminService/" + localStorage.restaurantSelected + "/getRestaurantSettings?lang=" + localStorage.language, undefined, undefined, undefined, false).done(d => {
            if (!this.pollTimer)
                return;
            this.setState(s => ({ checkCount: s.checkCount + 1 }));
            if (!d || typeof d !== "object" || !d.restaurant_settings)
                return;
            const features = d.restaurant_settings["enabled-features"];
            const places = features && features.choiceqr && features.choiceqr.places ? features.choiceqr.places : [];
            const place = places.find(p => p.name === placeName);
            if (place && place.varSymbol) {
                this.stopPolling();
                auth.setMyStatus({ ...auth.myStatus, ...d });
                this.setState({ phase: "connected" });
            }
        });
    }

    onConnect = (place) => {
        if (!place.domain || !place.clientId) {
            messageDialog(I18n.t("local.error_message"), I18n.t("admin_local.choiceqr_missing_domain_or_client"));
            return;
        }
        const restaurantId = this.props.myStatus.restaurant_global_id;
        const base = place.test
            ? "https://restaurant.eatwithme.online:8444/demo/eatwithme.server"
            : "https://instance.eatwithme.online/eatwithme.server";
        const redirectUrl = base + "/integration/choiceqr/oauth/" + restaurantId + "/" + encodeURIComponent(place.name);
        const digit = 1000 + (window.crypto.getRandomValues(new Uint32Array(1))[0] % 9000);
        const url = "https://" + place.domain + "/admin/open-api/connect"
            + "?clientId=" + encodeURIComponent(place.clientId)
            + "&redirectUrl=" + encodeURIComponent(redirectUrl)
            + "&scope=all&response_type=code"
            + "&digit=" + digit;
        this.setState({ connectInfo: { url, token: place.token, placeName: place.name }, copied: false });
    }

    onClick = (name) => {
        post("integration/choiceqr/syncMenu/" + this.props.myStatus.restaurant_id + "/" + name, {}).done(res => {
            if (res.status === "done")
                messageDialog(I18n.t("local.information"), I18n.t("admin_local.upload_successful"));
            else
                messageDialog(I18n.t("local.error_message"), res.message);
        });
    }

}

const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus && props.rootReducer.myStatus.restaurant_id) {
        return {
            myStatus: props.rootReducer.myStatus,
        };
    }
    return {};
};

export default connect(mapStateToProps)(withRouter(ChoiceQR));
